// extracted by mini-css-extract-plugin
module.exports = {"transparentBox":"Carousel_transparentBox__1EHNE","itemsBox":"Carousel_itemsBox__HpqbV","dots":"Carousel_dots__1MaKH","dot":"Carousel_dot__J842l","active":"Carousel_active__15XhW"};